module.exports = "/images/vendor/flag-icon-css/flags/4x3/tk.svg?1959d9de338fea49559ebcdbc11d7185";